export default "__VITE_ASSET__D4hU0vQT__"